import { Button } from "../styles/Button.styled";
import { useTranslation } from "react-i18next";

const DeferDocumentSendingEmail = () => {
  const { t } = useTranslation("enrollment");

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        margin: "2rem 0",
      }}
    >
      <div style={{ maxWidth: "800px" }}>
        <p style={{ marginTop: "1rem", fontSize: "1.2rem" }}>
          {t("sendingDeferEmail")}
        </p>
        <Button
          type="primary"
          size="large"
          style={{ marginTop: "1.5rem" }}
          onClick={() => {
            window.location.href = `https://cleanskyenergy.com/`;
          }}
        >
          {t("Back to Homepage")}
        </Button>
      </div>
    </div>
  );
};

export default DeferDocumentSendingEmail;
